import Banner from './Component/Banner/Banner';
import NavBar from './Component/NavBar/NavBar';
import './App.css';
import { originals, action, trending, comedy, horror, romance, documentary } from './urls'
import RowPost from './Component/RowPost/RowPost';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <RowPost url={originals} title='Netflix Originals' />
      <RowPost url={trending} title='Trending' isSmall />
      <RowPost url={action} title='Action' isSmall />
      <RowPost url={comedy} title='Comedy' isSmall />
      <RowPost url={horror} title='Horror' isSmall />
      <RowPost url={romance} title='Romance Movie' isSmall />
      <RowPost url={documentary} title='Documentaries' isSmall />
    </div>
  );
}

export default App;
